const RABBY_RDNS = 'io.rabby';
const eip6963Providers = new Map();
let eip6963Listening = false;
function getEthereum() {
    if (typeof window === 'undefined')
        return undefined;
    return window.ethereum;
}
/** Start listening for EIP-6963 wallet announcements (safe to call repeatedly). */
export function initEip6963Providers() {
    if (typeof window === 'undefined' || eip6963Listening)
        return;
    eip6963Listening = true;
    window.addEventListener('eip6963:announceProvider', (event) => {
        const detail = event.detail;
        eip6963Providers.set(detail.info.rdns, detail);
    });
    window.dispatchEvent(new Event('eip6963:requestProvider'));
}
function requestEip6963Providers() {
    initEip6963Providers();
    window.dispatchEvent(new Event('eip6963:requestProvider'));
}
function getRabbyWindowProvider() {
    if (typeof window === 'undefined')
        return undefined;
    return window.rabby;
}
/**
 * Rabby's direct EIP-1193 provider.
 * Avoids window.ethereum when Rabby is the default wallet — that object is an
 * aggregator that opens a multi-wallet picker instead of connecting to Rabby.
 */
export function getRabbyProvider() {
    if (typeof window === 'undefined')
        return undefined;
    requestEip6963Providers();
    const eip6963 = eip6963Providers.get(RABBY_RDNS);
    if (eip6963)
        return eip6963.provider;
    return getRabbyWindowProvider();
}
export function getRabbyInjectedTarget() {
    const provider = getRabbyProvider();
    if (!provider)
        return undefined;
    const detail = eip6963Providers.get(RABBY_RDNS);
    return {
        id: 'rabby',
        name: 'Rabby Wallet',
        provider,
        icon: detail?.info.icon,
    };
}
/** True MetaMask extension — excludes Rabby and other isMetaMask impostors. */
export function getMetaMaskProvider() {
    const ethereum = getEthereum();
    if (!ethereum)
        return undefined;
    if (ethereum.providers?.length) {
        return ethereum.providers.find((provider) => provider.isMetaMask && !provider.isRabby);
    }
    return ethereum.isMetaMask && !ethereum.isRabby ? ethereum : undefined;
}
export function isMetaMaskInstalled() {
    return Boolean(getMetaMaskProvider());
}
export function isRabbyInstalled() {
    if (typeof window === 'undefined')
        return false;
    requestEip6963Providers();
    if (eip6963Providers.has(RABBY_RDNS))
        return true;
    if (getRabbyWindowProvider())
        return true;
    const ethereum = getEthereum();
    if (!ethereum)
        return false;
    if (ethereum.isRabby)
        return true;
    return Boolean(ethereum.providers?.some((provider) => provider.isRabby));
}
export const EVM_WALLET_CONNECTOR_IDS = {
    MetaMask: ['metaMaskSDK', 'metaMask'],
    'Rabby Wallet': ['rabby', 'io.rabby'],
};
export function resolveEvmConnector(walletName, connectors) {
    const ids = EVM_WALLET_CONNECTOR_IDS[walletName];
    if (ids?.length) {
        const byId = connectors.find((connector) => ids.includes(connector.id));
        if (byId)
            return byId;
    }
    return connectors.find((connector) => connector.name === walletName);
}
export function isEvmWalletInstalled(walletName) {
    if (walletName === 'MetaMask')
        return isMetaMaskInstalled();
    if (walletName === 'Rabby Wallet')
        return isRabbyInstalled();
    return false;
}
